<template>
  <div class="product-comments">
    <div class="text-center">
      <h2 class="font-balo font-bold">{{ comments.length }} {{ $t("app.avis client") }}</h2>
      <div class="total-stars" v-if="avgStar > 0">
        <fa-rating
          :glyph="star"
          :spacing="5"
          :inactive-color="'#fff'"
          :active-color="'#FBB13C'"
          :border-color="'#FBB13C'"
          :border-width="3"
          :increment="1"
          :fixed-points="2"
          :rating="avgStar || 0"
          :item-size="30"
          :show-rating="false"
        ></fa-rating>
      </div>
    </div>
    <div class="comments-list">
      <ul>
        <li v-for="(item, index) in comments" :key="index">
          <div class="rating">
            <div class="stars">
              <fa-rating
                :glyph="star"
                :spacing="5"
                :inactive-color="'#fff'"
                :active-color="'#FBB13C'"
                :border-color="'#FBB13C'"
                :border-width="3"
                :increment="1"
                :fixed-points="2"
                :rating="Number(item.star) || 0"
                :item-size="15"
                :show-rating="false"
              ></fa-rating>
            </div>
            <b class="rating-text font-balo">{{ item.title }}</b>
          </div>
          <div class="comment-content">{{ item.content }}</div>
          <div class="comment-info font-bai">
            <div class="list-inline">
              <div class="item-inline">
                <div class="name font-bold">{{ item.name }}</div>
              </div>
              <div class="item-inline">
                <div class="time">{{ formatTimeAgo(item.date) }}</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="text-center">
      <router-link
        :to="`/feedback?reservation_id=${room.Id}`"
        class="btn font-balo font-bold"
      >{{ $t("app.Rédiger un avis") }}</router-link>
    </div> -->
  </div>
</template>

<script>
import { get } from "lodash";
import { mapState } from "vuex";
import { FaRating } from "vue-rate-it";
import Star from "vue-rate-it/glyphs/star";
import moment from "moment";
import { meanBy, round } from "lodash";
export default {
  name: "RoomComments",
  components: {
    FaRating
  },
  created() {
    this.star = Star;
  },
  data() {
    return {
      star: "",
      avgStar: 0
    };
  },
  mounted() {
    const stars = meanBy(this.comments, item => Number(item.star) || 0) || 0;
    this.avgStar = round(stars);
  },
  computed: {
    ...mapState({
      comments: state => get(state, "hotels.room.info.comment", []),
      room: state => get(state, "hotels.room", {})
    })
  },
  methods: {
    formatTimeAgo(time) {
      return moment(time, "hh:mm:ss DD-MM-YYYY").fromNow();
    }
  }
};
</script>
